import { useMutation } from '@tanstack/react-query';
import { resolveAccount } from './request';

export const useResolveAccount = () => {
  return useMutation({
    mutationFn: resolveAccount,
  });
};
